// === src/components/Bxinventar/List.jsx ===
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Alert,
  Button,
  Table,
  Spinner,
  Form,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";

function formatDateRo(val) {
  if (!val) return "";
  const s = String(val);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  return s;
}

export default function BxinventarList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // client paginate
  const [q, setQ] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/bxinventar/");
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = useMemo(() => {
    const s = (q || "").trim().toLowerCase();
    if (!s) return items;
    return items.filter((it) => {
      const doc = String(it.bxdoc_no ?? "").toLowerCase();
      const pos = String(it.pozitie ?? "").toLowerCase();
      return doc.includes(s) || pos.includes(s);
    });
  }, [items, q]);

  const pageCount = Math.max(1, Math.ceil(filtered.length / pageSize));
  const pageItems = useMemo(() => {
    const start = currentPage * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, currentPage, pageSize]);

  useEffect(() => {
    // dacă schimbi filtrul / pageSize, revii la prima pagină
    setCurrentPage(0);
  }, [q, pageSize]);

  return (
    <Container className="py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Inventare</h3>
        <Button as={Link} to="/bxinventar/new" variant="primary">
          + Adaugă
        </Button>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="d-flex gap-2 align-items-end mb-2">
        <Form.Group>
          <Form.Label className="mb-1">Caută</Form.Label>
          <Form.Control
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Doc No / Pozitie…"
          />
        </Form.Group>

        <Form.Group style={{ width: 160 }}>
          <Form.Label className="mb-1">Pe pagină</Form.Label>
          <Form.Select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[10, 20, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <div className="ms-auto">
          <Button variant="outline-secondary" onClick={load} disabled={loading}>
            Reîncarcă
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="py-4">
          <Spinner animation="border" className="me-2" />
          Se încarcă…
        </div>
      ) : (
        <>
          <Table striped bordered hover size="sm" responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Doc No</th>
                <th>Data Doc</th>
                <th>Gestiune</th>
                <th>Valoare</th>
                <th>Pozitie</th>
                <th className="text-end">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {pageItems.map((it) => (
                <tr key={it.id}>
                  <td>{it.id}</td>
                  <td>{it.bxdoc_no || "-"}</td>
                  <td>{formatDateRo(it.bxdoc_date) || "-"}</td>
                  <td>{it.bxgestiune_id}</td>
                  <td>{it.bxtftvavalue}</td>
                  <td>{it.pozitie || ""}</td>
                  <td className="text-end">
                    <Button
                      as={Link}
                      to={`/bxinventar/${it.id}/edit`}
                      size="sm"
                      variant="outline-primary"
                    >
                      Editează
                    </Button>
                  </td>
                </tr>
              ))}

              {pageItems.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center text-muted py-4">
                    Nu există înregistrări.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <ReactPaginate
            previousLabel={"← Înapoi"}
            nextLabel={"Înainte →"}
            pageCount={pageCount}
            forcePage={currentPage}
            onPageChange={(ev) => setCurrentPage(ev.selected)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            activeClassName={"active"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            renderOnZeroPageCount={null}
          />
        </>
      )}
    </Container>
  );
}
